import TopNav from "@/pages/home/components/TopNav";
import Hero from "@/pages/home/components/Hero";
import HotRanking from "@/pages/home/components/HotRanking";
import TimelineSection from "@/pages/home/components/TimelineSection";
import FocusSection from "@/pages/home/components/FocusSection";
import GallerySection from "@/pages/home/components/GallerySection";
import DiscussionSection from "@/pages/home/components/DiscussionSection";
import TagSection from "@/pages/home/components/TagSection";
import SubscribeFooter from "@/pages/home/components/SubscribeFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopNav />
      <main className="w-full flex-1">
        <Hero />
        <HotRanking />
        <TimelineSection />
        <FocusSection />
        <GallerySection />
        <DiscussionSection />
        <TagSection />
      </main>
      <SubscribeFooter />
    </div>
  );
}